import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const serpentSA76: IProductData = {
  id: "serpent-splice-sa76-500",
  name: "Serpent Audio Splice SA76",
  description: "1176-style FET compressor",
  images: ["/img/serpent_sa76_front.jpg"],
  details: [{
    label: "Description",
    markdown: `
The Splice-500 packs all of the sound and functionality of the acclaimed Splice MKII rack into a single 500 series module. 
Faithfully recreating the circuitry and sound of not one, but two classic FET compressors, the Splice-500’s unique mode switching allows the user to switch between the classic Blackface or vintage Bluestripe circuits at the push of a button. 
In addition, the Splice-500 can also mix and match the two for entirely new sounds that can only be found with the Splice (i.e. Blue Input Circuitry + Black Output Circuitry for “Blueface” mode or Black Input Circuitry + Blue Output Circuitry for “Blackstripe” mode.
`
  }, {
    label: "Overview",
    markdown: `
- Four Compressor circuits in one box:
- Input Circuit Black + Output Circuit Black = “Classic Blackface Mode”
- Input Blue + Output Blue = “Classic Bluestripe Mode”
- Input Blue + Output Black = “Blueface Mode” (Unique to the Splice)
- Input Black + Output Blue = “Blackstripe Mode” (Unique to the Splice)

- Stereo Linkable w/ front panel switch
- “All Buttons In” / Slam Mode front panel switch
- Integrated Mix/Blend Control w/ switchable bypassing for in-the-box parallel processing
- Integrated Sidechain High Pass Filter
- Selectable 600R Output loading allows the user to easily optimize the Splice™ for use with both vintage and modern equipment

- 45dB of Gain (with no limiting)
- Attack Time – 20 to 800 Microseconds
- Release Time – 50 Milliseconds to 1.1 Seconds
- Compression Ratios – 2:1, 4:1, 8:1, 12:1, 20:1 & Soft Bypass (BP)
- LED Gain Reduction Meter
- Backed by a 2 Year Limited Warranty
    `
  }, {
    label: "Specifications",
    markdown: `
- Maximum Current Consumption: 175mA* @ +/-16V
- Input: Constant 600R Input Attenuator, Floating Transformer Balanced
- Output: Floating Transformer Balanced
- Output (With Mix Enabled): <100 Ohm Output Impedance, Transformer-like
- Floating Output, Electronically Balanced (Accepts Balanced or Unbalanced Signals)
- External Send: <100 Ohm Output Impedance, Transformer-like Floating Output,
- Electronically Balanced (XLR) (Accepts Balanced or Unbalanced Signals)
- External Return: 22KHz Input Impedance, Electronically Balanced (XLR), (Accepts
- Balanced or Unbalanced Signals)
- Maximum Input Level: +30dbu with compression engaged and Input level knob set
- to max (fully clockwise)
- Maximum Output Level: +24dbu
- Output Load: 150 Ohm minimal
- Gain: 45db (+/-1dbu) with compression disabled (Ratio set to “BP”)
- Gain Reduction Element: FET
- THD+N: (20Hz-20KHz) Typically 0.5%
- Signal-To-Noise Ratio: >80dbu
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://serpentaudio.com/splice-mkii-500-series/" target="_blank">https://serpentaudio.com/splice-mkii-500-series/</a>
- <a to="https://serpentaudio.com/wp-content/uploads/2017/07/splice-500_v1.1_manual.pdf" target="_blank">576 Manual</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.SINGLE_SLOT, HASHTAGS.RECORDING, HASHTAGS.MIXING, HASHTAGS.API_500],
    manufacturer: BRAND.SERPENT,
  }
}